import { useLayoutEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

/**
 * Captures token from query or path, opens modal,
 * and REPLACES URL to "/" BEFORE paint (no /new_password flicker).
 */
export default function ResetPasswordHandler() {
    const location = useLocation();
    const navigate = useNavigate();
    const { token: tokenFromPath } = useParams();
    const { setUpdatePasswordModal, setResetToken } = useAuth();

    useLayoutEffect(() => {
        // token can come via ?token=... or /new_password/:token
        const params = new URLSearchParams(location.search);
        const tokenFromQuery = params.get("token");
        const token = tokenFromQuery || tokenFromPath || null;

        if (token) {
            setResetToken(token);
        }
        setUpdatePasswordModal(true);

        // Replace the URL to "/" immediately (no visual flicker)
        navigate("/", { replace: true, state: { fromReset: true } });
    }, [location.search, tokenFromPath, navigate, setResetToken, setUpdatePasswordModal]);

    return null;
}
